import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEighthNote = (props) => /* @__PURE__ */ _jsx("svg", {
	height: "800px",
	width: "800px",
	id: "_x32_",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 512 512",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M327.392,89.817C270.288,62.244,222.046,0,222.046,0v41.456v325.214c-17.83-6.55-38.908-8.486-60.632-4.292 c-52.168,10.023-88.075,51.179-80.247,91.872c7.851,40.714,56.48,65.578,108.638,55.512c46.306-8.915,79.741-42.349,81.171-78.257 h0.29V148.513c149.815,18.303,125.209,124.349,114.842,155.439C472.464,207.23,427.556,138.158,327.392,89.817z"
	}) })
});
export default SvgEighthNote;
